import React from 'react';
import styled from 'styled-components';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  '&.MuiCheckbox-root': {
    color: theme.uptimeColors.generalColors.icon.enabled,
  },
}));

export const UptimeCheckbox = (props: CheckboxProps) => {
  return <StyledCheckbox color="default" {...props} />;
};
